import "antd/lib/dropdown/style";
import _Dropdown from "antd/lib/dropdown";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import "antd/lib/card/style";
import _Card from "antd/lib/card";
var __jsx = React.createElement;
import { QuestionCircleOutlined, InfoCircleFilled } from '@ant-design/icons';
import React, { useState } from 'react';
var FeedbackButton = function FeedbackButton(props) {
  var collapsed = props.collapsed,
    buttonType = props.buttonType;
  var _useState = useState(false),
    visible = _useState[0],
    setVisible = _useState[1];
  var menuItems = [{
    label: __jsx(_Card, {
      size: "small",
      style: {
        padding: '0.5em',
        width: '410px'
      }
    }, "For help using the platform, check out:", __jsx("div", {
      style: {
        margin: '1em'
      }
    }, __jsx("a", {
      href: "https://www.parsebiosciences.com/data-analysis",
      target: "_blank",
      rel: "noreferrer"
    }, __jsx(InfoCircleFilled, null), ' ', "Our website"), ' ', __jsx("br", null), __jsx("a", {
      href: "https://support.parsebiosciences.com/hc/en-us/articles/27076682137236-Trailmaker-User-Guide",
      target: "_blank",
      rel: "noreferrer"
    }, __jsx(InfoCircleFilled, null), ' ', "User guide"), ' ', __jsx("br", null), __jsx("a", {
      href: "https://support.parsebiosciences.com/hc/en-us/categories/360004765711-Computational-Support",
      target: "_blank",
      rel: "noreferrer"
    }, __jsx(InfoCircleFilled, null), ' ', "Support suite including troubleshooting guides"), ' ', __jsx("br", null), __jsx("a", {
      href: "https://courses.trailmaker.parsebiosciences.com/",
      target: "_blank",
      rel: "noreferrer"
    }, __jsx(InfoCircleFilled, null), ' ', "Free single cell RNA-seq data analysis course")), __jsx(React.Fragment, null, "To report an issue or to receive 1-to-1 support from", __jsx("br", null), "a member of our team, send an email to", __jsx("br", null), __jsx("a", {
      href: "mailto:support@parsebiosciences.com",
      target: "_blank",
      rel: "noreferrer"
    }, ' ', "support@parsebiosciences.com"), "."), __jsx("br", null), "If your inquiry relates directly to your analysis, be sure", __jsx("br", null), "to include the relevant Run ID or Project ID.", __jsx("br", null)),
    key: 'feedback-button-contents',
    title: ''
  }];
  var buttonStyle = {};
  if (buttonType === 'text') {
    buttonStyle = {
      color: 'hsla(0, 0%, 100%, .65)'
    };
  }
  return __jsx(_Dropdown, {
    open: visible,
    onOpenChange: function onOpenChange(v) {
      return setVisible(v);
    },
    menu: {
      items: menuItems
    },
    placement: "topRight",
    trigger: "click"
  }, __jsx(_Button, {
    type: buttonType,
    icon: __jsx(QuestionCircleOutlined, null),
    style: buttonStyle
  }, !collapsed && 'Support'));
};
FeedbackButton.defaultProps = {
  buttonType: 'default'
};
export default FeedbackButton;